import { useTalkToBrian } from "@components/useTalkToBrian";
import {
  BrianMark,
  type BrianMarkState,
} from "@scribenote/brian-design-system";
import { useBrianBubble } from "@shell/brianBubble";
import type { ReactNode } from "react";

export const BrianCorner = ({ children }: { children?: ReactNode }) => {
  const talk = useTalkToBrian();
  const { content } = useBrianBubble();
  const state: BrianMarkState =
    talk.status === "connecting"
      ? "thinking"
      : talk.status === "live" && talk.speaking
        ? "speaking"
        : talk.isActive
          ? "listening"
          : "idle";

  return (
    <div className="fixed right-6 bottom-6 z-toast flex w-[min(34rem,calc(100vw-3rem))] flex-col items-end gap-3 pointer-events-none">
      {content && <div className="pointer-events-auto w-full">{content}</div>}
      {children}
      <button
        type="button"
        onClick={talk.toggle}
        aria-pressed={talk.isActive}
        aria-label={talk.isActive ? "Stop talking to Brian" : "Talk to Brian"}
        title={
          talk.status === "error" ? (talk.error ?? talk.errorTitle) : undefined
        }
        data-dd-action-name="Talk to Brian"
        className="pointer-events-auto cursor-pointer rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        <BrianMark state={state} size={40} />
      </button>
    </div>
  );
};
